<div class="homepage__title">
  <time datetime="29-03-2022" class="font-italic font-600">(29.03.2022)</time>
  <h1>
    <img src="static/images/png/title.png" alt="logo de la narration interactive Héritage" />
  </h1>
</div>

<style lang="scss">
  @import '../var';

  .homepage__title {
    position: relative;
    margin-top: clamp(30px, 7.922535211267606%, 45px);
    color: $primary-color;

    time {
      position: absolute;
      right: 0;
      top: 0;
      font-family: $text-font;
      font-size: clamp(12px, 3.75%, 18px);
    }

    h1 {
      padding: 0;
      margin: 0;
    }

    img {
      width: 100%;
    }
  }
</style>
